import React from 'react';
import dictionary from '../../utils/dictionary';
import ActivityLoader from '../Common/ActivityLoader';
import AlertError from './../Common/AlertError';
import TextInput from './../Common/TextInput';

class PopNewHoliday extends React.Component {

    state = {
        amount: '',
        info: '',
        searchList: false,
        loading: false,
        eventName: '',
        eventDate: ''
    }

    onChangeEvent = (event) => {
        this.setState({ eventName: event.target.value });
    }

    onChangeDate = (event) => {
        this.setState({ eventDate: event.target.value });
    }

    onConfirm = (event) => {
        event.preventDefault();
        const { eventDate, eventName } = this.state;
        if (eventDate.length > 0 && eventName.length) {
            this.setState({
                loading: true
            })
            this.props.onConfirm(eventName, eventDate);
        } else {
            this.setState({
                info: <AlertError message={dictionary._completeFields} />
            })
        }
    }



    render() {
        return (
            <div className="modal" id="modal_new_holiday">
                <div className="modal-dialog modal-dialog-centered" role="document">


                    <div className="modal-content modal-content-demo shadow">
                        <div className="modal-header">
                            <h6 className="modal-title">New Public Holiday</h6>
                            <button aria-label="Close" className="close" data-dismiss="modal" type="button"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            {this.state.info}
                            <form method="post" onSubmit={this.onConfirm}>

                                <TextInput
                                    label="Event Name"
                                    type="text"
                                    onChange={() => this.onChangeEvent}
                                    value={this.state.eventName}
                                />
                                <TextInput
                                    label="Event Date"
                                    type="date"
                                    onChange={() => this.onChangeDate}
                                    value={this.state.eventDate}
                                />

                            </form>



                        </div>
                        <div className="modal-footer">
                            {!this.state.loading && <>
                                <button className="btn ripple btn-primary" type="button" onClick={this.onConfirm}>Create Event</button>
                                <button className="btn ripple btn-secondary" type="button" data-dismiss="modal">Close</button>
                            </>}

                            {this.state.loading && <ActivityLoader />}
                        </div>
                    </div>


                </div>
            </div>
        )


    }
}

export default PopNewHoliday;
